import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, withModifiers as _withModifiers, normalizeStyle as _normalizeStyle } from "vue"

const _hoisted_1 = { class: "sqg-sideNav__header" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", null, null, -1)
const _hoisted_3 = [
  _hoisted_2
]
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__separator" }, null, -1)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__title" }, "Menu principal", -1)
const _hoisted_6 = { class: "sqg-sideNav__menu" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-home" })
], -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemText" }, "Accueil", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-layer-group" })
], -1)
const _hoisted_10 = { class: "sqg-sideNav__itemText" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("Mes dossiers en cours")
const _hoisted_12 = { class: "sqg-sideNav__bubble -white" }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-folder-tree" })
], -1)
const _hoisted_14 = { class: "sqg-sideNav__itemText" }
const _hoisted_15 = /*#__PURE__*/_createTextVNode("Mes dossiers archivés")
const _hoisted_16 = { class: "sqg-sideNav__bubble -white" }
const _hoisted_17 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-users" })
], -1)
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemText" }, "Mes utilisateurs", -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__separator" }, null, -1)
const _hoisted_20 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__title" }, "Mes dossiers ouverts", -1)
const _hoisted_21 = { class: "sqg-sideNav__folders" }
const _hoisted_22 = { class: "sqg-sideNav__itemLogo" }
const _hoisted_23 = { class: "sqg-sideNav__itemText" }
const _hoisted_24 = { class: "sqg-sideNav__bubble -large" }
const _hoisted_25 = ["onClick"]
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-level-up-alt" })
], -1)
const _hoisted_27 = { class: "sqg-sideNav__itemSubText" }
const _hoisted_28 = /*#__PURE__*/_createTextVNode("Formulaires")
const _hoisted_29 = { class: "sqg-sideNav__bubble -blue" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-level-up-alt" })
], -1)
const _hoisted_31 = { class: "sqg-sideNav__itemSubText" }
const _hoisted_32 = /*#__PURE__*/_createTextVNode("Fichiers")
const _hoisted_33 = { class: "sqg-sideNav__bubble -yellow" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemLogo" }, [
  /*#__PURE__*/_createElementVNode("i", { class: "fas fa-level-up-alt" })
], -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemSubText" }, "Utilisateurs", -1)
const _hoisted_36 = { class: "sqg-sideNav__profile" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__separator" }, null, -1)
const _hoisted_38 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__title" }, "Mon profil", -1)
const _hoisted_39 = { class: "sqg-sideNav__itemLogo" }
const _hoisted_40 = { class: "sqg-sideNav__notifications" }
const _hoisted_41 = /*#__PURE__*/_createElementVNode("i", { class: "fa-solid fa-bell" }, null, -1)
const _hoisted_42 = /*#__PURE__*/_createElementVNode("div", { class: "sqg-sideNav__itemText" }, "Notifications", -1)
const _hoisted_43 = { class: "sqg-sideNav__itemText" }

import {onMounted, ref, watch} from "vue";
import {useUserStore} from "@/stores/user";
import {storeToRefs} from "pinia";
import {useFoldersStore} from "@/stores/folders";
import {AxiosResponse} from "axios";
import {arrayHas, arrayToggle, getFolderIcone, randomColor, getStepIndicator} from "@/functions/utils";
import Loader from "@/components/Loader.vue";

//Store user

export default /*#__PURE__*/_defineComponent({
  setup(__props) {

const userStore = useUserStore();
const { user, notifications } = storeToRefs(userStore);
//STORE folders
const foldersStore = useFoldersStore();
const { currentFolder, folders } = storeToRefs(foldersStore);

//DATA
const open = ref(true);
const foldersOpen = ref([]);

const openFolder = (folder: any) => {
  if (!open.value) toggleSideNav();
  setFolder(folder.id);
}

watch(currentFolder, (newVal, oldVal) => {
  if (oldVal.id !== newVal.id && !arrayHas(foldersOpen.value, newVal.id)) {
    console.log('on toggle')
    arrayToggle(foldersOpen.value, newVal.id);
  }
});

const toggleIfSelect = (folderId: string) => {
  arrayToggle(foldersOpen.value, folderId);
}

const setFolder = (folderId: string) => {
  foldersStore.goLoader();
  foldersStore.getFolderById(folderId).then((response: AxiosResponse) => {
    foldersStore.setCurrentFolder(response.data);
    foldersStore.stopLoader();
  });
  userStore.goLoader();
  userStore.getUsersByFolder(folderId).then(() => {
    userStore.stopLoader();
  });
  userStore.setCurrentFolderId(folderId);
};

const memoryFoldersOpen = ref([]);
const toggleSideNav = () => {
  if (open.value) {
    memoryFoldersOpen.value = [...foldersOpen.value];
    foldersOpen.value.splice(0,foldersOpen.value.length);
    open.value = false;
  } else {
    foldersOpen.value = [...memoryFoldersOpen.value];
    open.value = true;
  }
}

const loader = ref(false);
onMounted(() => {
  userStore.getNotifications();
});

return (_ctx: any,_cache: any) => {
  const _component_Popper = _resolveComponent("Popper")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(['sqg-sideNav', { '-open' : open.value }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", {
        class: _normalizeClass(['sqg-sideNav__toggle', { '-open' : open.value }]),
        onClick: toggleSideNav
      }, _hoisted_3, 2)
    ]),
    _hoisted_4,
    (loader.value)
      ? (_openBlock(), _createBlock(Loader, {
          key: 0,
          size: "40"
        }))
      : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
          _hoisted_5,
          _createElementVNode("div", _hoisted_6, [
            _createVNode(_component_router_link, {
              class: "sqg-sideNav__navItem",
              to: "/home"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Popper, {
                  disabled: open.value,
                  arrow: true,
                  hover: true,
                  content: "Accueil",
                  placement: "right"
                }, {
                  default: _withCtx(() => [
                    _hoisted_7
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _hoisted_8
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "sqg-sideNav__navItem",
              to: "/folders"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Popper, {
                  disabled: open.value,
                  arrow: true,
                  hover: true,
                  content: "Mes dossiers en cours",
                  placement: "right"
                }, {
                  default: _withCtx(() => [
                    _hoisted_9
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("div", _hoisted_10, [
                  _hoisted_11,
                  _createElementVNode("div", _hoisted_12, _toDisplayString(_unref(folders).filter((folder) => folder.state !== 'termine').length), 1)
                ])
              ]),
              _: 1
            }),
            _createVNode(_component_router_link, {
              class: "sqg-sideNav__navItem",
              to: "/oldfolders"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Popper, {
                  disabled: open.value,
                  arrow: true,
                  hover: true,
                  content: "Mes dossiers archivés",
                  placement: "right"
                }, {
                  default: _withCtx(() => [
                    _hoisted_13
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _createElementVNode("div", _hoisted_16, _toDisplayString(_unref(folders).filter((folder) => folder.state === 'termine').length), 1)
                ])
              ]),
              _: 1
            }),
            (_unref(user).role !== 'gestionnaireDeDossier')
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "sqg-sideNav__navItem",
                  to: "/users"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Popper, {
                      disabled: open.value,
                      arrow: true,
                      hover: true,
                      content: "Mes utilisateurs",
                      placement: "right"
                    }, {
                      default: _withCtx(() => [
                        _hoisted_17
                      ]),
                      _: 1
                    }, 8, ["disabled"]),
                    _hoisted_18
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true)
          ]),
          _hoisted_19,
          _hoisted_20,
          _createElementVNode("div", _hoisted_21, [
            (_unref(user).preferences.currentFolderId !== '')
              ? (_openBlock(true), _createElementBlock(_Fragment, { key: 0 }, _renderList(_unref(user).preferences.favoriteFolders, (folder, index) => {
                  return (_openBlock(), _createElementBlock("div", {
                    key: index,
                    class: _normalizeClass(['sqg-sideNav__nav -folder', {'-open' : foldersOpen.value.includes(folder.id)} ])
                  }, [
                    _createVNode(_component_router_link, {
                      class: "sqg-sideNav__navItem",
                      to: `/folder/${folder.id}`,
                      onClick: _withModifiers(($event: any) => (openFolder(folder)), ["prevent"])
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_Popper, {
                          disabled: open.value,
                          arrow: true,
                          hover: true,
                          content: folder.name,
                          placement: "right"
                        }, {
                          default: _withCtx(() => [
                            _createElementVNode("div", _hoisted_22, [
                              _createElementVNode("i", {
                                class: _normalizeClass([_unref(getFolderIcone)(folder.state), {'-open' : foldersOpen.value.includes(folder.id)} ])
                              }, null, 2)
                            ])
                          ]),
                          _: 2
                        }, 1032, ["disabled", "content"]),
                        _createElementVNode("div", _hoisted_23, [
                          _createElementVNode("div", null, _toDisplayString(folder.name), 1),
                          _createElementVNode("div", _hoisted_24, _toDisplayString(_unref(getStepIndicator)(folder.state)), 1),
                          _createElementVNode("i", {
                            class: "fas fa-caret-down",
                            onClick: _withModifiers(($event: any) => (toggleIfSelect(folder.id)), ["prevent","stop"])
                          }, null, 8, _hoisted_25)
                        ])
                      ]),
                      _: 2
                    }, 1032, ["to", "onClick"]),
                    _createElementVNode("div", null, [
                      _createVNode(_component_router_link, {
                        class: "sqg-sideNav__subNavItem",
                        to: `/folder/${folder.id}/forms`
                      }, {
                        default: _withCtx(() => [
                          _hoisted_26,
                          _createElementVNode("div", _hoisted_27, [
                            _hoisted_28,
                            _createElementVNode("div", _hoisted_29, _toDisplayString(folder.nbForm), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_router_link, {
                        class: "sqg-sideNav__subNavItem",
                        to: `/folder/${folder.id}/files`
                      }, {
                        default: _withCtx(() => [
                          _hoisted_30,
                          _createElementVNode("div", _hoisted_31, [
                            _hoisted_32,
                            _createElementVNode("div", _hoisted_33, _toDisplayString(folder.nbFile), 1)
                          ])
                        ]),
                        _: 2
                      }, 1032, ["to"]),
                      _createVNode(_component_router_link, {
                        class: "sqg-sideNav__subNavItem",
                        to: `/folder/${folder.id}/users`
                      }, {
                        default: _withCtx(() => [
                          _hoisted_34,
                          _hoisted_35
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ])
                  ], 2))
                }), 128))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_36, [
            _hoisted_37,
            _hoisted_38,
            (_unref(notifications))
              ? (_openBlock(), _createBlock(_component_router_link, {
                  key: 0,
                  class: "sqg-sideNav__navItem",
                  to: "/notifications"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_Popper, {
                      disabled: open.value,
                      arrow: true,
                      hover: true,
                      content: _unref(notifications).length + ' Notifications',
                      placement: "right"
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("div", _hoisted_39, [
                          _createElementVNode("span", _hoisted_40, _toDisplayString(_unref(notifications).length), 1),
                          _hoisted_41
                        ])
                      ]),
                      _: 1
                    }, 8, ["disabled", "content"]),
                    _hoisted_42
                  ]),
                  _: 1
                }))
              : _createCommentVNode("", true),
            _createVNode(_component_router_link, {
              class: "sqg-sideNav__navItem",
              to: "/profile"
            }, {
              default: _withCtx(() => [
                _createVNode(_component_Popper, {
                  disabled: open.value,
                  arrow: true,
                  hover: true,
                  content: "Mon profile",
                  placement: "right"
                }, {
                  default: _withCtx(() => [
                    _createElementVNode("div", {
                      class: "sqg-sideNav__itemLogo",
                      style: _normalizeStyle(`background-color: ${_unref(randomColor)(_unref(user).id)}`)
                    }, _toDisplayString(_unref(user).firstname[0]) + _toDisplayString(_unref(user).lastname[0]), 5)
                  ]),
                  _: 1
                }, 8, ["disabled"]),
                _createElementVNode("div", _hoisted_43, _toDisplayString(_unref(user).firstname) + " " + _toDisplayString(_unref(user).lastname), 1)
              ]),
              _: 1
            })
          ])
        ], 64))
  ], 2))
}
}

})